import React from 'react';
import { login } from '../actions/session';
import { connect } from 'react-redux';
import { alertError, alertSuccess } from '../config/toast';
import { passwordRE, mobileRE } from '../config/regex';
import loginReq from '../config/httpRoutes';
import { Row, Form, Col, Card, Button/* , Nav */ } from 'react-bootstrap';
import TextInput from '../components/textInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { saveId, saveToken } from '../config/storage';

class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			phone: '',
			password: '',
			errors: {phone: '', password: ''},
			laoding: false
		};
	}
	
	handleChange = ({ target: { name, value } }) => {
		this.setState({[name]: value});
	}

	validate = () => {
		const { phone, password } = this.state;
		let errors = { phone: '', password: '' }, isValid = true;

		if(!mobileRE.test(phone)) {
			errors.phone = "Enter valid phone";
			isValid = false;
		}
		
		if(!passwordRE.test(password)) {
			errors.password = "Password must have at least 4 characters";
			isValid = false;
		}
		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { phone, password } = this.state;
		
		if(this.validate()) {
			this.setState({loading: true});
			loginReq({phone, password})
			.then( (res) => {
				this.setState({loading: false});
				const { phone, id:userid } = res.data;
				alertSuccess("Login successful");
				this.props.login({ phone, userid });
				saveToken(res.headers.auth);
				saveId(userid);
				this.props.history.push('/admins');
			}).catch( (err) => {
				this.setState({loading: false});
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				// if(err?.response?.data?.code === "UserNotConfirmedException") {
				// 	this.props.history.push('/verify');
				// }
			});
		}
	}

	render() {
		const { phone, password, errors, loading } = this.state;
		const { handleChange, handleSubmit } = this;
		return (
			<Row style={{marginLeft: 0, marginRight: 0}}>
				<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
					<Card style={{marginTop: '20%'}}>
						<Card.Header>
							<Card.Title style={{textAlign: 'center'}}>Login</Card.Title>
						</Card.Header>
						<Card.Body>
							<Form onSubmit={handleSubmit}>
								<Form.Group>
									<TextInput onChange={handleChange} value={phone} error={errors.phone} name="phone" label="Phone" type="phone" />
								</Form.Group>

								<Form.Group>
									<TextInput onChange={handleChange} value={password} error={errors.password} name="password" label="Password" type="password" />
								</Form.Group>

								<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
									{loading ?
										<FontAwesomeIcon icon={faSpinner} spin />
									:
										'Login'
									}
								</Button>
							</Form>
						</Card.Body>
						{/* <Card.Footer>
							<small><Nav.Link href="/register">CREATE NEW ACCOUNT</Nav.Link></small>
							<small><Nav.Link href="/verify">VERIFY ACCOUNT</Nav.Link></small>
						</Card.Footer> */}
					</Card>
				</Col>
			</Row>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	// setLoading: (load) => {dispatch(setLoading(load));},
	login: (data) => {dispatch(login(data));}
});

export default connect(null, mapDispatchToProps)(Login);